<template>
  <div class='thumbnails-slider' :class='{ "no-photo": displayNoPhotoPlaceholder }' @click.stop='() => {}'>
    <div class='thumbnails-carousel' v-if='!displayNoPhotoPlaceholder'>
      <v-slide-group
        v-model="model"
        show-arrows
      >
        <v-slide-item
          v-for="(thumbnail, index) in thumbnailUrlsWithPorts"
          :key='`slide-item-${index}`'
        >
          <div class='image-section' @click.stop='thumbnailClicked(thumbnail.oldIndex)'>
            <v-badge
              class='badge'
              :value='thumbnail.port'
              :content='thumbnail.port'
              bordered
              overlap
              offset-x='25px'
              offset-y='15px'
            >
              <div class='thumbnail'>
                <v-img
                  :src='thumbnail.url'
                  :max-width='95'
                  :min-width='95'
                  :min-height='75'
                  :max-height='75'
                  position='top center'
                />
              </div>
            </v-badge>
          </div>
        </v-slide-item>
      </v-slide-group>
    </div>
    <div class='no-photo-placeholder' v-else>
      <no-photo-placeholder/>
    </div>
  </div>
</template>

<script>
import NoPhotoPlaceholder from '@/components/common/NoPhotoPlaceholder.vue';
import { getFileUrl } from '@/amplify/auth';

export default {
  name: 'ThumbnailSlider',
  components: { NoPhotoPlaceholder },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
      description: 'Thumbnail image urls',
    },
  },
  data() {
    return {
      model: null,
      thumbnailUrlsWithPorts: [],
      loading: false,
    };
  },
  watch: {
    items: {
      async handler() {
        this.loading = true;
        this.thumbnailUrlsWithPorts = [];
        this.thumbnailUrlsWithPorts = this.items.map(async (item, index) => {
          const url = await getFileUrl(item.url);
          return {
            oldIndex: index,
            url,
            port: item.port,
          };
        });
        this.thumbnailUrlsWithPorts = await Promise.all(this.thumbnailUrlsWithPorts);
        this.thumbnailUrlsWithPorts = this.thumbnailUrlsWithPorts
          .filter(item => item.port.length)
          .sort((item1, item2) => (parseInt(item1.port, 10) - parseInt(item2.port, 10) > 0 ? 1 : -1));
        this.loading = false;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    displayNoPhotoPlaceholder() {
      return !this.thumbnailUrlsWithPorts.length && !this.loading;
    },
  },
  methods: {
    thumbnailClicked(index) {
      this.$emit('thumbnailClicked', index);
    },
  },
};
</script>

<style lang='scss'>
.thumbnails-carousel {
  .v-slide-group__wrapper {
    padding-left: 0px;
    background-color: transparent;
  }
  .badge {
    .v-badge__badge {
      border-radius: 3px !important;
    }
  }
  .v-slide-group__wrapper {
    padding-left: 0px;
  }
  .v-image {
    &:hover {
      cursor: pointer;
    }
  }
  .v-slide-group {
    max-width: 70%;
  }
  .v-slide-group--has-affixes {
    left: -52px;
  }
}
</style>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.thumbnails-slider {
  .thumbnails-carousel {
    width: fit-content;
    min-width: rem(470);
    max-width: rem(470);
    justify-content: center;
    align-items: center;
    .image-section {
      .thumbnail {
        border: $border-width-thin solid var(--input-border-focus);
        border-radius: $radius-sm;
        max-width: rem(97);
        max-height: rem(77);
        min-width: rem(97);
        min-height: rem(77);
        transition: transform 0.15s ease;
        &:hover {
          transform: scale(1.2);
        }
        .v-image {
          &:hover {
            cursor: pointer;
          }
        }
      }
      &:hover {
        cursor: pointer;
      }
      padding: rem(5);
      align-items: center;
      justify-content: center;
      margin-right: $space-3;
      max-width: rem(102);
      max-height: rem(82);
      min-width: rem(102);
      min-height: rem(82);
    }
  }
  .no-photo-placeholder {
    margin-left: rem(5);
  }
  &.no-photo {
    position: absolute;
    left: 0;
  }
}
</style>
